import sheamus from '../assets/testimonials/sheamus.png'
import ollie from '../assets/testimonials/ollie.png'
import jeff from '../assets/testimonials/jeff.png'
import aaron from '../assets/testimonials/aaron.png'
import rhodes from '../assets/testimonials/rhodes.png'
import philip from '../assets/testimonials/philip.jpeg'
import michael from '../assets/testimonials/michael.jpeg'
import artem from '../assets/testimonials/artem.png'
import usFlag from '../assets/testimonials/us-flag.svg'
import gbFlag from '../assets/testimonials/gb-flag.svg'
import uaFlag from '../assets/testimonials/ua-flag.svg'

const testimonials = [
  {
    id: 1,
    name: 'Sheamus McGovern',
    position: 'Founder & CEO at ODSC',
    flag: usFlag,
    photo: sheamus,
    text: 'What stood out most about CrypCons was their attention to detail and ability to keep the project on time and budget. The end client was happy with CrypCons\' work. The team performed exceptionally and delivered high-quality work.',
    linkedin: 'https://www.linkedin.com/in/sheamus'
  },
  {
    id: 2,
    name: 'Ollie Maitland',
    position: 'Co-Founder & CPO at Capitalise',
    flag: gbFlag,
    photo: ollie,
    text: 'We\'ve worked with CrypCons to add an additional team alongside our core engineering and products teams. They have worked closely with us becoming fully integrated with us and delivering an excellent standard of architecture and engineering expertise.',
    linkedin: 'https://www.linkedin.com/in/olliemaitland/'
  },
  {
    id: 3,
    name: 'Jeff Wallace',
    position: 'Co-Founder at Silicon Valley in Your Pocket',
    flag: usFlag,
    photo: jeff,
    text: 'We are thrilled to have such a knowledgeable, skilled and collaborative team in CrypCons as we build our business into the future. They helped us to create an excellent solution, one that met our early pilot needs but that was also scalable to meet our long-term requirements.',
    linkedin: 'https://www.linkedin.com/in/jeffwallace913/'
  },
  {
    id: 4,
    name: 'Aaron Brooks',
    position: 'Managing Director and Co-Founder at WayThru Innovations',
    flag: usFlag,
    photo: aaron,
    text: 'Big shoutout to CrypCons for their outstanding support! The team\'s commitment to our projects has been remarkable, and we\'ve found a great partner in them. The Team Lead\'s dedication is commendable, ensuring smooth collaboration.',
    linkedin: 'https://www.linkedin.com/in/aaron-brooks-aa37a65a/'
  },
  {
    id: 5,
    name: 'Rhodes Kriske',
    position: 'Marketing Director at WayThru Innovations',
    flag: usFlag,
    photo: rhodes,
    text: 'Working with CrypCons has been an exceptional experience. Their professionalism and expertise have significantly contributed to our project success.',
    linkedin: 'https://www.linkedin.com/in/rhodes-kriske/'
  },
  {
    id: 6,
    name: 'Dr. Philip Cabréus',
    position: 'Founder & CEO at Atlas Well',
    flag: usFlag,
    photo: philip,
    text: 'Thanks to CrypCons\' efforts, the client has achieved a 99% system uptime and enhanced security. The team has also streamlined the client\'s CI/CD pipeline, allowing them to push new features weekly and secure paying customers after the launch.',
    linkedin: 'https://www.linkedin.com/in/philipcabreus/overlay/about-this-profile/'
  },
  {
    id: 7,
    name: 'Michael Stone',
    position: 'Head of Engineering and Product at StrideUp',
    flag: gbFlag,
    photo: michael,
    text: 'The team has communicated fantastically and provided timely deliverables throughout the engagement. CrypCons\' flexibility is a hallmark of their performance.',
    linkedin: 'https://www.linkedin.com/in/michaelstone1/'
  },
  {
    id: 8,
    name: 'Artem Arutyunyan',
    position: 'Head of Digital at Media Development Foundation',
    flag: uaFlag,
    photo: artem,
    text: 'With our High-load News Media project, we have reached our goals to increase analytics by rebuilding the infrastructure, boosting the performance of the website, and improving the news cloud panel for our journalists. Hromadske.ua is extremely thankful and satisfied with the costs spent since the results we gained are perfect.',
    linkedin: 'https://www.linkedin.com/in/artem-nyan/'
  }
]

export default testimonials
